import { jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { sizeMap, onlineStatusSizeMap, onlineStatusPositionMap } from './size.mjs';
import { px2rem } from '../../helpers/rem.mjs';
import { RsProfilePlaceholderXl, RsProfilePlaceholderL, RsProfilePlaceholderM, RsProfilePlaceholderS, RsProfilePlaceholderXs, Svg36Userprofile } from '@moim/icons';

var ImageStyle = css(["object-fit:cover;width:100%;height:100%;overflow:hidden;border-radius:", ";"], function (props) {
  return props.shape === "round" ? "50%" : px2rem(4);
});
var RawImage = styled.img.withConfig({
  displayName: "RawImage",
  componentId: "sc-1ibujaz-0"
})(["", ";border:", " solid ", ";"], ImageStyle, px2rem(1), function (props) {
  return props.theme.colorV2.colorSet.grey10;
});
var ClipPathG = styled.g.withConfig({
  displayName: "ClipPathG",
  componentId: "sc-1ibujaz-1"
})(["width:100%;height:100%;clip-path:url(#userProfile-", ");"], function (props) {
  return props.size;
});
var UserPlaceholderXL = styled(RsProfilePlaceholderXl).attrs(function (props) {
  return {
    iconColor: props.theme.getThemeElementColor({
      targetColor: "fog400",
      elementPalette: props.elementPaletteProps,
      fallback: props.theme.colorV2.colorSet.grey300
    })
  };
}).withConfig({
  displayName: "UserPlaceholderXL",
  componentId: "sc-1ibujaz-2"
})(["", ""], ImageStyle);
var UserPlaceholderL = styled(RsProfilePlaceholderL).attrs(function (props) {
  return {
    iconColor: props.theme.getThemeElementColor({
      targetColor: "fog400",
      elementPalette: props.elementPaletteProps,
      fallback: props.theme.colorV2.colorSet.grey300
    })
  };
}).withConfig({
  displayName: "UserPlaceholderL",
  componentId: "sc-1ibujaz-3"
})(["", ""], ImageStyle);
var UserPlaceholderM = styled(RsProfilePlaceholderM).attrs(function (props) {
  return {
    iconColor: props.theme.getThemeElementColor({
      targetColor: "fog400",
      elementPalette: props.elementPaletteProps,
      fallback: props.theme.colorV2.colorSet.grey300
    })
  };
}).withConfig({
  displayName: "UserPlaceholderM",
  componentId: "sc-1ibujaz-4"
})(["", ""], ImageStyle);
var UserPlaceholderS = styled(RsProfilePlaceholderS).attrs(function (props) {
  return {
    iconColor: props.theme.getThemeElementColor({
      targetColor: "fog400",
      elementPalette: props.elementPaletteProps,
      fallback: props.theme.colorV2.colorSet.grey300
    })
  };
}).withConfig({
  displayName: "UserPlaceholderS",
  componentId: "sc-1ibujaz-5"
})(["", ""], ImageStyle);
var UserPlaceholderXS = styled(RsProfilePlaceholderXs).attrs(function (props) {
  return {
    iconColor: props.theme.getThemeElementColor({
      targetColor: "fog400",
      elementPalette: props.elementPaletteProps,
      fallback: props.theme.colorV2.colorSet.grey300
    })
  };
}).withConfig({
  displayName: "UserPlaceholderXS",
  componentId: "sc-1ibujaz-6"
})(["", ""], ImageStyle);
var UserPlaceholder = styled(Svg36Userprofile).attrs(function (props) {
  return {
    iconColor: props.theme.getThemeElementColor({
      targetColor: "fog400",
      elementPalette: props.elementPaletteProps,
      fallback: props.theme.colorV2.colorSet.grey300
    })
  };
}).withConfig({
  displayName: "UserPlaceholder",
  componentId: "sc-1ibujaz-7"
})(["", ""], ImageStyle);
var UserPlaceholderWithMask = function UserPlaceholderWithMask(_ref) {
  var size = _ref.size,
    elementPaletteProps = _ref.elementPaletteProps;
  switch (size) {
    case "xl":
      return jsx(UserPlaceholderXL, {
        elementPaletteProps: elementPaletteProps
      });
    case "l":
      return jsx(UserPlaceholderL, {
        elementPaletteProps: elementPaletteProps
      });
    case "m":
      return jsx(UserPlaceholderM, {
        elementPaletteProps: elementPaletteProps
      });
    case "s":
      return jsx(UserPlaceholderS, {
        elementPaletteProps: elementPaletteProps
      });
    case "xs":
      return jsx(UserPlaceholderXS, {
        elementPaletteProps: elementPaletteProps
      });
    default:
      return null;
  }
};
var OnlineStatus = styled.div.withConfig({
  displayName: "OnlineStatus",
  componentId: "sc-1ibujaz-8"
})(["position:absolute;border-radius:50%;overflow:hidden;background-color:", ";&::before{content:\"\";border-radius:50%;background-color:", ";position:absolute;top:0;bottom:0;left:0;right:0;}"], function (props) {
  return props.theme.colorV2.colorSet.white1000;
}, function (props) {
  return props.isOnline ? "#60ff00" : props.theme.colorV2.colorSet.grey300;
});
var Wrapper = styled.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1ibujaz-9"
})(["display:flex;align-items:center;justify-content:center;position:relative;width:", ";height:", ";", "{width:", ";height:", ";right:", ";bottom:", ";}"], function (props) {
  return px2rem(sizeMap.get(props.size));
}, function (props) {
  return px2rem(sizeMap.get(props.size));
}, OnlineStatus, function (props) {
  return px2rem(onlineStatusSizeMap.get(props.size));
}, function (props) {
  return px2rem(onlineStatusSizeMap.get(props.size));
}, function (props) {
  return px2rem(onlineStatusPositionMap.get(props.size).right);
}, function (props) {
  return px2rem(onlineStatusPositionMap.get(props.size).bottom);
});
styled.g.withConfig({
  displayName: "UserProfileWithMask",
  componentId: "sc-1ibujaz-10"
})(["clip-path:url(#userProfile-", ");"], function (props) {
  return "".concat(props.size);
});
styled.div.withConfig({
  displayName: "UserProfileMaskWrapper",
  componentId: "sc-1ibujaz-11"
})(["width:0;height:0;"]);

export { ClipPathG, ImageStyle, OnlineStatus, RawImage, UserPlaceholder, UserPlaceholderL, UserPlaceholderM, UserPlaceholderS, UserPlaceholderWithMask, UserPlaceholderXL, UserPlaceholderXS, Wrapper };
